/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import "DesignSystem/Fonts/Inter-500.css"
import ErrorList from 'DesignSystem/Images/ErrorList/index'
import React from 'react'
import SupportLink from './SupportLink/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/PerformTrace/Content/Error"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="Error.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-4QcjJ': isBefore ? 0 : 1,'--ty-2-4QcjJ': isBefore ? "8px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<ErrorList
  viewPath={`${viewPath}/ErrorList`}
 width={150}
 height="auto"
/>
<span
  data-testid="Error.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
Something went wrong
</span>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color="rgba(0,0,0,0.5)"
 marginTop={8}
 text="Looks like the data wasn't retrieved"
/>
<SupportLink
  viewPath={`${viewPath}/SupportLink`}
/>
</div>
{children}
</React.Fragment>)
}